// src/app/modules/Incidents/components/CreateIncidentModal.jsx
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../Dashbord/_redux/dashboard/Actions';
import { X, AlertTriangle } from 'lucide-react';
import './CreateIncidentModal.scss';

export function CreateIncidentModal({ show, onHide, organizationId, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    type: 'security_threat',
    severity: 'medium',
    location: {
      address: '',
    },
  });

  function handleChange(e) {
    const { name, value } = e.target;
    if (name === 'address') {
      setFormData(prev => ({
        ...prev,
        location: { ...prev.location, address: value }
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      await dispatch(actions.addData('create_incident', {
        ...formData,
        organization_id: organizationId
      }));
      
      onHide();
      if (onSuccess) onSuccess();
      
      setFormData({
        title: '',
        description: '',
        type: 'security_threat',
        severity: 'medium',
        location: { address: '' },
      });
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="create-incident-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Report Incident</h5>
          <button className="close" onClick={onHide} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Title *</label>
              <input
                type="text"
                name="title"
                className="form-control"
                value={formData.title}
                onChange={handleChange}
                placeholder="Brief description of the incident"
                required
              />
            </div>

            <div className="form-group">
              <label>Description *</label>
              <textarea
                name="description"
                className="form-control"
                rows={4}
                value={formData.description}
                onChange={handleChange}
                placeholder="Provide detailed information about the incident..."
                required
              />
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Type *</label>
                  <select
                    name="type"
                    className="form-control"
                    value={formData.type}
                    onChange={handleChange}
                    required
                  >
                    <option value="security_threat">Security Threat</option>
                    <option value="medical">Medical Emergency</option>
                    <option value="fire">Fire</option>
                    <option value="crime">Crime</option>
                    <option value="accident">Accident</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Severity *</label>
                  <select
                    name="severity"
                    className="form-control"
                    value={formData.severity}
                    onChange={handleChange}
                    required
                  >
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                    <option value="critical">Critical</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>Location</label>
              <input
                type="text"
                name="address"
                className="form-control"
                value={formData.location.address}
                onChange={handleChange}
                placeholder="Enter location or address"
              />
            </div>

            <div className="alert alert-info">
              <strong>Note:</strong> Security personnel will be notified immediately upon submission.
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={onHide} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-danger" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2"></span>
                  Reporting...
                </>
              ) : (
                <>
                  <AlertTriangle size={16} className="mr-2" />
                  Report Incident
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}